import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { DataSourceQuery } from '../../datasource/data-source-query';
import { IDataSource } from '../../datasource/data-source';
import { UiStyleService } from '../../services/ui-style.service';
import { E5coreUiDatagridBase } from './component/e5core-ui-datagrid-base';


@Component({
	selector: 'e5core-ui-datagrid',
	template:
		`<span *ngIf="!error" [ngSwitch]="style.current()">
			<e5core-ui-datagrid-material #SearchResults *ngSwitchCase='2' 
				[datasource]='datasource'  [query]='query' [autoSearch]='autoSearch'
				(open)='onOpen($event)' (link)='onLink($event)' (select)='onSelect($event)'>
				</e5core-ui-datagrid-material>
			</span>
		<div *ngIf="error" class="e5core-component-error">{{error}}</div>`
})
export class E5coreUiDatagridComponent implements OnInit {

	@Input() datasource: IDataSource;
	@Input() query: DataSourceQuery ;
	@Input() autoSearch:boolean ;
	@Input() pagesizes: number[];

	@Output() open = new EventEmitter<any>();
	@Output() select = new EventEmitter<any>();
	@Output() link = new EventEmitter<string>();

	error : string ;

	@ViewChildren("SearchResults") datagridChildren !: QueryList<E5coreUiDatagridBase>;

	constructor(public style:UiStyleService) { }

	ngOnInit() {
	}

	/**
 	 *  Pass the open work item event on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onOpen(data: any) {
		this.open.emit(data);
	}

	/**
	 *  Pass the select link on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onSelect(data: any) {
		this.select.emit(data);
	}

	/**
	 *  Pass the open link on to any listener.
	 * @param data the row of data, including the "Id" from the table.
	 */
	onLink(link: string) {
		this.link.emit(link);
	}

	/**
	 * Execute a search with the required search expression values.
	 * @param expression the fields and values required to perform the search.
	 */
	public search(query:DataSourceQuery) {
		this.datagridChildren.forEach( c => c.search(query)) ;
	}

	/**
	 * Clear the search results.
	 */
	public reset() {
		this.datagridChildren.forEach( c => c.reset()) ;
	}

	/**
	 * Refresh the search results at the current page.
	 */
	public refresh() {  
		this.datagridChildren.forEach( c => c.refresh()) ;  
	}

}
